import { privateApi } from 'services';
import { FacebookLeadGenForm } from './types';
import { privateApiWithRouteLeavingCancelation } from '../ApiService/ApiServiceWithRouteLeavingCancelation';

const checkFacebookLeadGenFormEmploymentCampaignValidity = async (
    facebookPageId: string,
    formId: string,
): Promise<{ valid: boolean }> =>
    privateApi.get<{ valid: boolean }>(
        `facebook/graph/facebook-pages/${facebookPageId}/leadgen-forms/${formId}/employment-campaign-validity`,
    );

const fetchAllLeadGenFormsForBusinessAccount = async (businessAccountId: string): Promise<FacebookLeadGenForm[]> =>
    privateApi.get<FacebookLeadGenForm[]>(`business-accounts/${businessAccountId}/facebook/graph/leadgen-forms`);

export const FacebookLeadGenFormGateway = {
    checkFacebookLeadGenFormEmploymentCampaignValidity,
    fetchAllLeadGenFormsForBusinessAccount,
};

const cancelableFetchFacebookLeadGenForms = async (facebookPageId: string): Promise<FacebookLeadGenForm[]> =>
    privateApiWithRouteLeavingCancelation.get<FacebookLeadGenForm[]>(
        `facebook/graph/facebook-pages/${facebookPageId}/leadgen-forms`,
    );

export const CancelableFacebookLeadGenFormGateway = {
    cancelableFetchFacebookLeadGenForms,
};
